const firebaseConfig = {
    apiKey: "AIzaSyB8bHqb3PJFslRmHN71yQ7PztakEcAZ4as",
    authDomain: "creative-agency-ea348.firebaseapp.com",
    databaseURL: "https://creative-agency-ea348.firebaseio.com",
    projectId: "creative-agency-ea348",
    storageBucket: "creative-agency-ea348.appspot.com",
    messagingSenderId: "559807893837",
    appId: "1:559807893837:web:8e8af062579d4bf029e704"
  };
export default firebaseConfig;